import { Dialog, DialogContent, DialogTitle, Grid, MenuItem, Paper, Select } from "@mui/material";
import React, { useEffect, useState } from "react";
import Draggable from "react-draggable";
import MDBox from "../../../Components/MDBox";
import MDInput from "../../../Components/MDInput";
import MDTypography from "../../../Components/MDTypography";
import { ConditionKindEnum } from "../../../Types/Enums/ConditionKindEnum";
import { v4 as uuid } from "uuid";
import MDButton from "../../../Components/MDButton";
import { useFormik } from "formik";
import * as Yup from "yup";
import { AsnafCategoryModel } from "../../../Api/Models/AsnafCategoryModel";
import { SuccessToaast } from "../../../utils/toast/Toast";

function PaperComponent(props: any) {
  return (
    <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}
const validationSchema = Yup.object().shape({
  Title: Yup.string().typeError("نام بانک الزامی است").required("نام بانک الزامی است "),
});
export default function AddAsnaf(props: { open: boolean; setClose: any; onDone: any }) {
  const [salMali, setSalMali] = useState("1401");
  const asnafCategory = new AsnafCategoryModel();
  const formik = useFormik({
    validationSchema,
    initialValues: { Title: "", SalMali: "" },
    onSubmit: (data) => {
      var model = { Title: data.Title, Description: "", SalMali: salMali };
      asnafCategory.crete(model).then((r) => {
        SuccessToaast("با موفقیت انجام شد");
        props.onDone();
      });
    },
  });


  return (
    <Dialog open={props.open} onClose={props.setClose} PaperComponent={PaperComponent} aria-labelledby="draggable-dialog-title">
      <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
        <MDTypography variant="h">افزودن صنف</MDTypography>
      </DialogTitle>
      <DialogContent>
        <MDBox component="form" role="form" onSubmit={formik.handleSubmit}>
          <Grid container textAlign={"center"} justifyContent="center" gap={"10px 0"}>
            <Grid item xs={4} alignSelf="center">
              <MDTypography fontSize={"14px"}>عنوان</MDTypography>
            </Grid>
            <Grid item xs={8}>
              <MDInput
                name="Title"
                fullWidth
                size="small"
                onChange={formik.handleChange}
                error={formik.touched.Title && Boolean(formik.errors.Title)}
                value={formik.values.Title}
              />
            </Grid>
            <Grid item xs={4} alignSelf="center">
              <MDTypography fontSize={"14px"}>سال مالی</MDTypography>
            </Grid>
            <Grid item xs={8}>
              <Select fullWidth size="small" value={salMali} onChange={(r) => setSalMali(r.target.value)}>
                {[1390, 1391, 1392, 1393, 1394, 1395, 1396, 1397, 1398, 1399, 1400, 1401].map((r) => (
                  <MenuItem value={r} key={uuid()}>
                    {r}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
          </Grid>
          <Grid container justifyContent={"center"} alignItems="center">
            <Grid item xs={3} mt={2} mx={5}>
              <MDButton color="error" fullWidth variant="outlined">
                بازگشت
              </MDButton>
            </Grid>
            <Grid item xs={3} mt={2} mx={5}>
              <MDButton color="success" fullWidth variant="outlined" type="submit">
                ثبت
              </MDButton>
            </Grid>
          </Grid>
        </MDBox>
      </DialogContent>
    </Dialog>
  );
}
